import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=fde61fd0&scoped=true&"
import script from "./MenuEdit.vue?vue&type=script&lang=js&"
export * from "./MenuEdit.vue?vue&type=script&lang=js&"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=fde61fd0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde61fd0",
  null
  
)

export default component.exports